import { PlaybookDescriptor } from "./model";

export const load_local_playbooks = (): { data: PlaybookDescriptor[] } => {
  return {
    data: [
      {
        id: "mpip",
        posture: "data_protection",
        action:
          "Automate MPIP Sensitivity Labels on Microsoft 365 Information At Rest",
        cascading_threats: [],
        threats: ["Data Leaks", "Compliance Violation"],
        is_available: true,
        type: "cloud",
        reduce_risk: "high",
        group: "Data Protection",
        friction: "low",
        protection_tier: 1,
        description: `Run a cloud script to apply sensitivity labels using Cognni's information categories using <a class="playbook-desc-link" href='/microsoft-labeling' target='_blank'>Cognni Labeling Automation Rules</a>`,
        criteria: {
          findingTypes: ["sensitive_information"],
          labelIds: [],
          serviceId: "msft_365",
          applicationId: "msft_onedrive",
        },

        display: {
          template_title: `Apply MPIP Sensitivity labels on {~application} for {~label} information {~finding_type} detection`,
          long_desc: `This policy involves the automation of sensitivity labels,
             leveraging Cognni’s autonomous sensitive information recognition to automate MPIP labels to enforce data loss prevention (DLP) labeling rules. 
             The automation process is a key stride in embedding a DLP strategy within an organization’s data security framework.
             By categorizing sensitive information accurately, this policy enables the protection of critical data assets from potential
             threats such as data leaks and compliance violations, thus fortifying the organization's data security posture and compliance with security and regulatory standards.`,
          entity_type: "FILE",
          pseudo_script: `
  # Pseudocode to Apply Sensitivity Labels using Cognni's Information Categories
  
  # Function to invoke Cognni API and get the information categories and corresponding labels
  Function Get-CognniInfoCategories {
  # API call to Cognni to get information categories
  # Assuming an API token is needed for authorization
  $apiToken = "<YOUR_API_TOKEN>"
  $headers = @{
      "Authorization" = "Bearer $apiToken"
      "Content-Type"  = "application/json"
  }
  
  $cognniCategories = Invoke-RestMethod -Uri "https://api.cognni.ai/information-categories" -Method Get -Headers $headers
  return $cognniCategories
  }
  
  # Function to apply labels using Microsoft's sensitivity labeling
  Function Apply-MicrosoftSensitivityLabel {
  param (
      [string]$documentId,   # The ID of the document to label
      [string]$sensitivityLabel # The sensitivity label to apply
  )
  
  Set-SensitivityLabel -DocumentId $documentId -Label $sensitivityLabel
  Write-Host "Applied $sensitivityLabel label to document ID: $documentId"
  }
  
  # Main script execution
  $cognniCategories = Get-CognniInfoCategories
  
  foreach ($category in $cognniCategories) {
  $documents = Get-Documents -Category $category.Name # Placeholder cmdlet to get documents based on Cognni category
  foreach ($document in $documents) {
      Apply-MicrosoftSensitivityLabel -documentId $document.Id -sensitivityLabel $category.MicrosoftLabel
  }`,
        },
      },
    ],
  };
};
